import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { useMediaData } from './data/MediaDataContext.jsx';
import SlidePage1 from './slide_1/SlidePage1.jsx';
import './slider.css';
import PhotoSphereViewer from './slide_2/PhotoSphereViewer.jsx'; 
import MapViewer from './slide_3/MapViewer.jsx';

const Carousel = forwardRef(({ openPanel }, ref) => {
  const { mediaData, isMediaLoading, error } = useMediaData();
  const photoSphereRef = useRef();

  const [currentPage, setCurrentPage] = useState(0);


  useImperativeHandle(ref, () => ({ closePanel }));


  // 인라인 스타일 정의
  const carouselStyle = {
    display: 'flex',
    transition: 'transform 0.5s ease-in-out',
    transform: `translateX(-${currentPage * 100}%)`,
    width: '100%',
    //height: '100dvh',
    height: '100%',
  };

  const pageStyle = {
    minWidth: '100%',
    //height: '100dvh',
    height: '100%',
    flexShrink: 0, // 크기 변경 방지
  };

  const nextButtonStyle = {
    position: 'absolute',
    right: '0',
    top: '0',
    bottom: '0',
  };

  const prevButtonStyle = {
    position: 'absolute',
    left: '0',
    top: '0',
    bottom: '0',
  };

  const closePanel = (event) => {
    if (photoSphereRef.current) {
      photoSphereRef.current.closePanel();
    }
  };

  if (isMediaLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }


  const handleNextClick = () => {
    setCurrentPage((prevPage) => (prevPage + 1) % (slides.length + 1));
  };

  const handlePrevClick = () => {
    var p = currentPage - 1;
    if (p <0) p =1;
    setCurrentPage(p);
  };

 // mediaData를 video는 1개씩, image는 4개씩 분할하여 SlidePage1에 전달
 const slides = [];
 let tempImages = [];
 
 //한 페이지에 총 몇장의 이미지를 보여줄지 설정
 const maxImageCountPerPage = 2;

 for (let i = 0; i < mediaData.length; i++) {
   if (mediaData[i].type === 'video') {
     if (tempImages.length > 0) {
       slides.push(tempImages);
       tempImages = [];
     }
     slides.push([mediaData[i]]);
   } else {
     tempImages.push(mediaData[i]);
     if (tempImages.length === maxImageCountPerPage) {
       slides.push(tempImages);
       tempImages = [];
     }
   }
 }

 if (tempImages.length > 0) {
   slides.push(tempImages);
 }

 const isFirstPage = currentPage === 0;
 const isLastPage = currentPage === slides.length;

 return (
   <div className="carousel-container" style={{ overflow: 'hidden', width: '100vw', height: '100%' }}>
     <div className="carousel" style={carouselStyle}>
       {slides.map((slideData, index) => (
         <div className="page text-white" style={pageStyle} key={index}>
           <SlidePage1 openPanel={openPanel} mediaData={slideData} />
         </div>
       ))}
       {/* {isLastPage && (
         <div className="page text-white" style={pageStyle} key="photoSphere">
           <PhotoSphereViewer ref={photoSphereRef} openPanel={openPanel}/>
         </div>
       )} */}
       {isLastPage && (
         <div className="page text-white" style={pageStyle} key="photoSphere">
           <MapViewer ref={photoSphereRef} openPanel={openPanel}/>
         </div>
       )}
     </div>

     {!isLastPage && (
       <div onClick={handleNextClick} style={nextButtonStyle} className="topMenu" id="nextBtn">
         <span aria-hidden="true" className="carousel-next-icon">
           <img src="arrow_right.png" width="50px" alt="right" />
         </span>
       </div>
     )}

     {!isFirstPage && (
       <div onClick={handlePrevClick} style={prevButtonStyle} className="topMenu">
         <span aria-hidden="true" className="carousel-prev-icon">
           <img src="arrow_left.png" width="50px" alt="left" />
         </span>
       </div>
     )}

     {/* <div className="bottom-address">
       <div style={{ textAlign: 'right' }}>
         1(재)시안 이사장 이상훈 사업자등록번호 126-82-00201 경기도 광주시 오포안로17
       </div>
       <div style={{ textAlign: 'right' }}>
         Copyright Ⓒ SIAN FAMILY MEMORIAL PARK, ALL RIGHTS RESERVED.
       </div>
     </div> */}
   </div>
 );
});

export default Carousel;